export default "__VITE_ASSET__CGAwEYvj__"